<div
  [class.page-while-print]="isNeedPrint$ | async"
  class="page-wrapper"
>
  @if (showImpersonateBar) {
    <div class="impersonate-bar">
      <div class="info-pannel">
        <div class="main-label">You are logged in as</div>
        <div class="info-container">
          <mat-icon
            [svgIcon]="'person'"
            class="person-impersonate"
          ></mat-icon>
          <div class="user-info">
            <div class="user-name-container">{{ impersonateUserName }}</div>
            <div class="user-email-container">{{ impersonateUserEmail }}</div>
          </div>
        </div>
      </div>
      <button
        (click)="logout()"
        class="logout-button"
      >
        Finish Session
      </button>
    </div>
  }
  @if (tags) {
    <input
      type="hidden"
      id="ifs-tags-id"
      value="{{ tags }}"
    />
  }
  <router-outlet></router-outlet>
</div>
<ngx-spinner
  [fullScreen]="false"
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-atom"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

@if (isNeedPrint$ | async) {
  <app-print-data></app-print-data>
}
